import { motion } from "framer-motion";

const CASES = [
  {
    img: "https://laser-machines.com/images/case01.webp",
    title: "Shipbuilding Industry",
    desc: "Hudong-Zhonghua Shipbuilding Group sought more efficient processing, material savings and labor reduction. Penta Laser delivered a complete laser cutting and welding solution to match.",
  },
  {
    img: "https://laser-machines.com/images/case02.webp",
    title: "Structural Steel Industry",
    desc: "In 2022 Shanghai Steel Structure Construction acquired the VII 12025 series large-format laser cutting and coding machine - a significant step in lifting production capability.",
  },
  {
    img: "https://laser-machines.com/images/case03.webp",
    title: "Automotive Industry",
    desc: "BYD Auto, a frontrunner in new energy vehicles, chose Penta's GAN series 3D laser cutting machine for its exceptional precision, speed and efficiency.",
  },
];

export default function CaseStudies() {
  return (
    <section id="cases" data-testid="cases-section" className="bg-[#F4F5F7]">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-8 lg:py-20">
        <h2 className="text-center text-3xl font-light uppercase tracking-wide text-[#222] sm:text-4xl" data-testid="cases-heading">
          Case Studies
        </h2>
        <div className="mt-12 grid grid-cols-1 gap-8 md:grid-cols-3">
          {CASES.map((c, i) => (
            <motion.article
              key={c.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="group bg-white shadow-[0_2px_12px_rgba(0,0,0,0.08)] transition-shadow duration-200 hover:shadow-[0_6px_24px_rgba(0,0,0,0.14)]"
              data-testid={`case-card-${i}`}
            >
              <div className="overflow-hidden">
                <img src={c.img} alt={c.title} loading="lazy" className="aspect-[16/10] w-full object-cover transition-transform duration-300 group-hover:scale-105" />
              </div>
              <div className="p-5">
                <div className="text-xs text-muted-foreground">Laser Machines used in</div>
                <h3 className="mt-1 text-lg font-semibold text-[#222]">{c.title}</h3>
                <p className="mt-2 text-[13px] leading-relaxed text-muted-foreground">{c.desc}</p>
                <a href="#contact" data-testid={`case-readmore-${i}`} className="mt-3 inline-block text-xs font-semibold uppercase tracking-wide text-[#333] underline underline-offset-4 transition-colors hover:text-laser">
                  Read More
                </a>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
